import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AudioMessage_EarMode } from '../generated/audio_message';

interface AudioSettingsState {
  microphoneOn: boolean;
  microphoneMaybeTalking: boolean;
  microphoneTransmitting: boolean;
  desiredEarMode: AudioMessage_EarMode;
}

const initialState: AudioSettingsState = {
  microphoneOn: false,
  microphoneMaybeTalking: false,
  microphoneTransmitting: false,
  desiredEarMode: AudioMessage_EarMode.PUSH_TO_TALK,
};

export const audioSettingsSlice = createSlice({
  name: 'audioSettings',
  initialState,
  reducers: {
    setMicrophoneOn: (state, action: PayloadAction<boolean>) => {
      state.microphoneOn = action.payload;
    },
    setMicrophoneMaybeTalking: (state, action: PayloadAction<boolean>) => {
      state.microphoneMaybeTalking = action.payload;
    },
    setMicrophoneTransmitting: (state, action: PayloadAction<boolean>) => {
      state.microphoneTransmitting = action.payload;
    },
    setDesiredEarMode: (state, action: PayloadAction<AudioMessage_EarMode>) => {
      state.desiredEarMode = action.payload;
    },
  }
});

export const {
  setMicrophoneOn,
  setMicrophoneMaybeTalking,
  setMicrophoneTransmitting,
  setDesiredEarMode,
} = audioSettingsSlice.actions;

// Define a type for RootState without importing it to avoid circular dependencies
type RootState = {
  audioSettings: AudioSettingsState;
  [key: string]: any;
};

export const selectMicrophoneOn = (state: RootState) => 
  state.audioSettings.microphoneOn;
export const selectMicrophoneMaybeTalking = (state: RootState) => 
  state.audioSettings.microphoneMaybeTalking;
export const selectMicrophoneTransmitting = (state: RootState) => 
  state.audioSettings.microphoneTransmitting;
export const selectDesiredEarMode = (state: RootState) => 
  state.audioSettings.desiredEarMode;

export default audioSettingsSlice.reducer;
